import { BASVURU_DENETIM_SONUC_KRITERI_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const BasvuruDenetimSonucuKriteriGuncelle = (props) => {
    let data ={};
    if(props !== undefined)
    data = JSON.stringify(props);
    return postRequest({url:BASVURU_DENETIM_SONUC_KRITERI_GUNCELLE,data}).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
    });
}

export default BasvuruDenetimSonucuKriteriGuncelle;